import React from 'react';

// components
import { Spacer } from '@ontruck/orc';
import LoadSpinner from 'components/LoadSpinner';

const BasicLoader = ({ className, ...props }) => (
  <Spacer pTop="L" pBottom="L">
    <LoadSpinner />
  </Spacer>
);

export default BasicLoader;
